import React, { useCallback } from 'react';

import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';
import { useDictionary, useMediaConfig } from 'bdvp-common/src/hooks/config';
import { useModalStore } from 'bdvp-common/src/hooks/store';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useQueryInfoQuery from '../hooks/store/useQueryInfoQuery';
import useSearchPaginationStore from '../hooks/store/useSearchPaginationStore';
import useSelectedFiltersStore from '../hooks/store/useSelectedFiltersStore';
import useSearchQueryParam from '../hooks/store/useSearchQueryParam';
import SearchPageComponent from '../components/SearchPage';

const { FILTER_MODAL_NAME } = modalConstants;

const SearchPage = () => {

    const { searchQuery, queryType } = useSearchQueryParam();
    const { error } = useQueryInfoQuery(searchQuery, queryType);
    const { setPage } = useSearchPaginationStore();
    const { setSelectedFilters } = useSelectedFiltersStore();
    const { modalHide, modalShow } = useModalStore();

    const resetPageNumber = useCallback(() => setPage(0),[setPage]);
    const closeFilterModal = useCallback(() => modalHide(FILTER_MODAL_NAME), [modalHide]);
    const openFilterModal = useCallback(() => modalShow(FILTER_MODAL_NAME), [modalShow]);

    return (
        <SearchPageComponent
            query={searchQuery}
            queryInfoError={error}
            resetPageNumber={resetPageNumber}
            setSelectedFilters={setSelectedFilters}
            closeFilterModal={closeFilterModal}
            openFilterModal={openFilterModal}
        />
    );

};

export default SearchPage;
